module.exports = __webpack_public_path__ + "static/media/navLogo.b8f4739f.png";